import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-2 pb-2 text-left" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "mt-2 pb-2 text-left" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = { class: "mt-2 pb-2 text-left" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = { class: "mt-2 pb-2 text-left" }
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = { class: "mt-1" }
const _hoisted_17 = { class: "mt-2 pb-2 text-left" }
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = { class: "mt-1" }
const _hoisted_20 = { class: "w-full" }
const _hoisted_21 = { class: "mt-1" }
const _hoisted_22 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_23 = { class: "block truncate" }
const _hoisted_24 = { class: "text-amber-900 bg-amber-100 cursor-default select-none relative py-2 pl-10 pr-4" }
const _hoisted_25 = { class: "font-medium block truncate" }
const _hoisted_26 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }

import {computed, ref, watch} from "vue";
  import {
    Dialog,
    DialogTitle,
    DialogOverlay,
    TransitionRoot,
    TransitionChild,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
  } from "@headlessui/vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentConfigAddDepositBankDialog',
  props: { form: Object, show: Boolean, bankProviderList: Object },
  emits: ["submit", "update:show", "update:form", "close"],
  setup(__props, { emit }) {

const props = __props

  const showSync = computed({
    get: () => props.show,
    set: (value) => emit("update:show", value),
  });

  const submitForm = () => {
    emit('submit', { ...props.form, bankId: selectedOption.value.value })
    selectedOption.value = { label: "-Select-", value: null }
  }

  const selectedOption = ref({ label: "-Select-", value: null });


  
  
  const onlyNumber = (event: KeyboardEvent) => {
    if (isNaN(Number(event.data))) {
      props.form.bankAccountNumber = props.form.bankAccountNumber.slice(0, -1)
    }
  };
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[6] || (_cache[6] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.PaymentDepositBankCreateDepositBank")), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.depositBankName")), 1),
                        _createElementVNode("div", _hoisted_7, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.name) = $event)),
                            name: "name",
                            id: "name",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, __props.form.name]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.depositBankBankAccountNumber")), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.form.bankAccountNumber) = $event)),
                            name: "bankAccountNumber",
                            id: "bankAccountNumber",
                            onInput: onlyNumber,
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 544), [
                            [_vModelText, __props.form.bankAccountNumber]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.depositBankBankAccountNameEn")), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.form.bankAccountNameEn) = $event)),
                            name: "bankAccountNameEn",
                            id: "bankAccountNameEn",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, __props.form.bankAccountNameEn]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.depositBankBankAccountNameTh")), 1),
                        _createElementVNode("div", _hoisted_16, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.form.bankAccountNameTh) = $event)),
                            name: "bankAccountNameTh",
                            id: "bankAccountNameTh",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, __props.form.bankAccountNameTh]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.depositBankBankProvider")), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_unref(Listbox), {
                              modelValue: selectedOption.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedOption).value = $event))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_unref(ListboxButton), { class: "w-full py-2 pl-3 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_22, [
                                        _createElementVNode("span", _hoisted_23, _toDisplayString(selectedOption.value.label), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_Transition, {
                                    "leave-active-class": "transition duration-100 ease-in",
                                    "leave-from-class": "opacity-100",
                                    "leave-to-class": "opacity-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ListboxOptions), { class: "absolute w-10/12 max-h-60 mt-1 mx-2 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.bankProviderList, (option, index) => {
                                            return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                              key: index,
                                              value: {label: `${option.code} [${option.nameEn}]`, value: option.id},
                                              as: "template"
                                            }, {
                                              default: _withCtx(({ active, selected }) => [
                                                _createElementVNode("li", _hoisted_24, [
                                                  _createElementVNode("span", _hoisted_25, _toDisplayString(`${option.code} [${option.nameEn}]`), 1)
                                                ])
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: submitForm,
                      class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                    }, " Add "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close'))),
                      class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                      ref: "cancelButtonRef"
                    }, " Cancel ", 512)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})